<template >
  <div>
    <el-upload
      v-if="isShow"
      :accept='acceptExts[format]'
      ref="upload"
      :file-list="fileList"
      :auto-upload="true"
      :data="access"
      :action="action"
      list-type="picture"
      :multiple="false"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :before-remove="beforeRemove"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :on-preview="handlePreview"
      :disabled="IsUpload==false">
      <el-button size="small" type="primary" v-if="IsUpload" :disabled="IsShowUpload">点击上传</el-button>
    </el-upload>
    <!-- <source-preview :data.sync="sourceUrl"></source-preview> -->
    <!--课件预览-->
    <div class="PreviewResourcces" v-show="dialogVisiblePreviewResources">
      <!-- <i @click="dialogClose()" style="color:red;" class="el-icon-close yl-source-preview-show-close-wrapper"></i> -->
      <!-- <i v-if="auth.userType == 1" @click="dialogClose()" style="color:red;" class="el-icon-close yk-stu-preview-source-close-wrapper"></i> -->
      <PreparingCourseware
        v-if="dialogVisiblePreviewResources"
        :sourceId="docId"
        :savesession="false"
        @dialogVisiblePreviewResources="dialogClose()"
      ></PreparingCourseware>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
// import { GetFileInfo } from 'api/design/v1.design.questionfile.ts';
import { GetDocUrl } from "api/v1.design.Enclosure";
// import SourcePreview from "pages/SourcePreview.vue";
import PreparingCourseware from "components/PreparingCourseware.vue";
export default {
  name: "oss-question-file",
  components: {
    // SourcePreview,
    PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: []
    },
    fileList: {
      type: Array,
      default: []
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created() {
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  data() {
    return {
      docId: "",
      acceptExts: {
        image: '.jpg,.jpeg,.png',
        file: '.jpg,.jpeg,.png,.gif,.zip,.pdf'
      },
      // fileList: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      format:"image",
      removeids: [],
      dialogVisiblePreviewResources: false,
      IsShowUpload: false,
      defaultCover: require("assets/images/noCover.jpg"),
      isShow: true
    };
  },
  watch: {
    filesList: function(val) {
      debugger;
      this.removeids = [];
      let url = "";
    },
    dialogVisiblePreviewResources: function(val) {
      this.$emit("Preview", val);
    }
  },
  methods: {
    dialogClose() {
      this.IsShowUpload = false;
      this.dialogVisiblePreviewResources = false;
    },
    beforeUpload(file) {
      this.IsShowUpload = true;
      debugger;
      return this.addFile(file);
    },
    onRemoveHandler(file) {
      this.fileList = this.fileList.filter(
        p => p.docId !== file.docId
      );
      this.removeids.splice(this.removeids.indexOf(file.docId), 1);
      this.removeids = this.removeids.filter(p => p !== file.docId);
      this.$emit("update:fileList", this.fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handlePreview(file) {
      this.dialogVisiblePreviewResources = true;
      this.docId = file.docId;
    },
    onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.IsShowUpload = false;
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      this.fileList.push({
        name: res.fileName,
        url: res.docPath,
        docId: res.docId
      });
      this.$emit("update:fileList", this.fileList);
    }
  }
};
</script>

<style lang="scss">
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg {
    size: 26px;
    position: fixed;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
  }
}
</style>
